/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturInstallIcon20Solid = forwardRef('KonturInstallIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1.55-7.51a1.625 1.625 0 1 0-1.06 1.06l2.73 2.73a.75.75 0 1 0 1.06-1.06l-2.73-2.73ZM9.817 5.378a.625.625 0 0 1-.05-1.25A5.945 5.945 0 0 1 14.5 6.224a5.945 5.945 0 0 1 1.241 5.023.625.625 0 0 1-1.221-.265 4.68 4.68 0 0 0-.977-3.954 4.68 4.68 0 0 0-3.726-1.648Z" })));
});
